import React, { useState, useMemo, useEffect, useCallback } from 'react'
import Button from 'react-bootstrap/esm/Button'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import { Input, FormCustom, TextArea, Select, SwitchToggle } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import ProductList from '../Product/ProductList'
import { toast } from 'react-toastify';
import CustomersList from '../Customers/CustomersList'
import Loading from '../../Components/Layout/Styled/Loading'

const SaleFormTest = ({ data, onSubmit, disablebSubmit, loadSubmit, viewSubmit }) => {
    const [row, setRow] = useState({
        p_id_document: data.id_document,
        p_number_invoice_doc: data.number_invoice_doc,
        p_id_customers: data.id_customers,
        p_id_type_price: data.id_type_price,
        p_full_name_customers: data.full_name_customers,
        p_name_branch_office: data.name_branch_office,
        p_email_customers: data.email_customers,
        p_point_current_customers: data.point_current_customers,
        p_has_invoice_doc: data.has_invoice_doc,
        p_concept_cfdi_doc: data.concept_cfdi_doc,
        p_id_branch_office: data.id_branch_office,
        p_id_period: data.id_period,
        p_code_period: data.code_period,
        p_details: data.details,
        p_id_type_format_pay: data.id_type_format_pay,
        p_id_dispatch: data.id_dispatch,
        p_id_type_format_pay_2: data.id_type_format_pay_2,
        p_amount_format_pay: data.amount_format_pay,
        p_amount_format_pay_2: data.amount_format_pay_2,
        p_sponsor_received: data.sponsor_received,
        p_id_sponsor: data.id_sponsor,
        p_customers_info: {},
        p_zip_code_invoice: data.zip_code_invoice,
        p_full_name_invoice: data.full_name_invoice,
        p_invoice_change: data.invoice_change,
    })

    const [saleHasPromo, setSaleHasPromo] = useState(false)
    /* const [sponsorValidated, setSponsorValidated] = useState(false) */
    const [twoMethods, setTwoMethods] = useState(!isNaN(parseInt(data.id_type_format_pay_2)))

    const [ivaTax, setIvaTax] = useState(parseFloat(data.value_tax))
    const [isUsa, setIsUsa] = useState(false);

    const notExistsStock = {
        exists: false,
        details: {
            message: '',
            products: []
        }
    }

    const [showLoading, setShowLoading] = useState(false)
    const [regimen, setRegimen] = useState([]);
    const [cfdi, setCfdi] = useState([])

    const [ready, setReady] = useState(false)
    const [modalProducts, setModalProducts] = useState(false)
    const [showModalCustomers, setShowModalCustomers] = useState(false)
    const [existsStock, setExistsStock] = useState({
        ...notExistsStock,
        exists: !isNaN(parseInt(data.id_document))
    })

    const [listTypeFormatPay, setListTypeFormatPay] = useState([])
    const [listBranchOffice, setListBranchOffice] = useState([])
    const [listStatusDispatch, setListStatusDispatch] = useState([])

    const [isMass, setIsMass] = useState(false)
    const [validateProducts, setValidateProducts] = useState(false)
    const [listProducts, setListProducts] = useState('')

    const [cashback, setCashback] = useState('')
    const [promosReceived, setPromosReceived] = useState([]);
    const [discount, setDiscount] = useState({
        status: false,
        discount: 0,
        discount_type: ''
    })

    const [formatPayFac] = useState([
        { id: 'PUE', name: 'PUE' },
        { id: 'PPD', name: 'PPD' },
    ])

    const cboFormatPayFac = useCallback(() => {
        if (!row.p_customers_info?.payment_form_facturama) {
            return ''
        }

        let find = formatPayFac.find(w => w.id === row.p_customers_info?.payment_form_facturama)

        if (!find) {
            return ''
        }

        return {
            label: find.name,
            value: find.id
        }
    }, [row.p_customers_info, formatPayFac])

    useEffect(() => {
        if (data.hasOwnProperty('discount_amount')) {
            if (parseFloat(data.discount_amount) > 0) {
                setDiscount({
                    status: true,
                    discount: parseFloat(data.discount_amount),
                })
            }
        }
    }, [data])

    const typeFormayPay = useMemo(() => {
        if (!row.p_id_type_format_pay) {
            return
        }

        let finded = listTypeFormatPay.find(t => parseInt(row.p_id_type_format_pay) === parseInt(t.id_type_format_pay))

        if (!finded) {
            return
        }
        return {
            label: finded.name_format_pay,
            value: finded.id_type_format_pay
        }
    }, [row.p_id_type_format_pay, listTypeFormatPay])

    const typeFormayPay2 = useMemo(() => {
        if (!row.p_id_type_format_pay) {
            return
        }

        let finded = listTypeFormatPay.find(t => parseInt(row.p_id_type_format_pay_2) === parseInt(t.id_type_format_pay))

        if (!finded) {
            return
        }
        return {
            label: finded.name_format_pay,
            value: finded.id_type_format_pay
        }
    }, [row.p_id_type_format_pay, row.p_id_type_format_pay_2, listTypeFormatPay])

    const statusDispatch = useMemo(() => {
        if (!row.p_id_dispatch) {
            return
        }

        let finded = listStatusDispatch.find(t => parseInt(row.p_id_dispatch) === parseInt(t.id_dispatch))

        if (!finded) {
            return
        }
        return {
            label: finded.name_dispatch,
            value: finded.id_dispatch
        }
    }, [row.p_id_dispatch, listStatusDispatch])

    const branchOffice = useMemo(() => {
        if (!row.p_id_branch_office) {
            return ''
        }

        let finded = listBranchOffice.find(t => parseInt(row.p_id_branch_office) === parseInt(t.id_branch_office))

        if (!finded) {
            return ''
        }
        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [row.p_id_branch_office, listBranchOffice])

    const cboRegimen = useMemo(() => {
        if (!row?.p_customers_info?.id_regimen) {
            return ''
        }

        let finded = regimen.find(t => parseInt(row.p_customers_info.id_regimen) === parseInt(t.id_regimen))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_regimen} - ${finded.name_regimen}`,
            value: finded.id_regimen
        }
    }, [row.p_customers_info.id_regimen, regimen])

    const cboCfdi = useMemo(() => {
        if (!row?.p_customers_info?.id_cfdi) {
            return ''
        }

        let finded = cfdi.find(t => row.p_customers_info.id_cfdi === t.id_cfdi)

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
            value: finded.id_cfdi
        }
    }, [row.p_customers_info.id_cfdi, cfdi])

    const handleValidateStock = () => {
        if (row.p_details.length === 0) {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar productos', toast })
            return
        }

        if (row.p_details.some(d => isNaN(parseInt(d.qty)))) {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar cantidades', toast })
            return
        }

        if (!existsStock.exists) {
            setShowLoading(true)
            Controllers.product.get_product_validate_stock({
                p_details: row.p_details.map(r => {
                    return {
                        p_id_product: r.id_product,
                        p_key_product: r.key_product,
                        p_name_product: r.name_product,
                        p_price: r.price,
                        p_qty: r.qty,
                        p_point: r.point,
                        p_value_business: r.value_business,
                        p_pack_product: r.pack_product
                    }
                })
            }).then(res => {
                setExistsStock({
                    exists: res.response === 'success',
                    details: {
                        message: res.message,
                        products: res.data
                    }
                })
            }).catch(_ => {
                setExistsStock({
                    exists: false,
                    details: {
                        message: 'No se ha podido verificar stock.',
                        products: []
                    }
                })
            }).finally(_ => setShowLoading(false))
        }
    }

    const handleShowModalProducts = () => {
        if (!row.p_id_customers) {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Cliente', toast })
            return
        }
        if (!row.p_id_branch_office) {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Sucursal', toast })
            return
        }

        setModalProducts(true)
    }
    const handleHideModalProducts = () => setModalProducts(false)

    useEffect(() => {
        Promise.all([
            Controllers.period.get_period_current(),
            Controllers.type_format_pay.get_type_format_pay(),
            Controllers.worker.get_worker_branch_office_public(),
            Controllers.dispatch.get_dispatch(),
            Controllers.regimen.get_regimen(),
            Controllers.cfdi.get_cfdi()
        ]).then(res => {
            if (res[0].data?.id_period && data.id_document === '') {
                setRow({ ...row, p_id_period: res[0].data?.id_period, p_code_period: res[0].data?.code_period })
            }
            setListTypeFormatPay(res[1].data)
            setListBranchOffice(res[2].data)
            setListStatusDispatch(res[3].data)
            setRegimen(res[4].data)
            setCfdi(res[5].data)
            setReady(true)
        })
    }, [])

    const getSubtotal = useCallback(() => {
        if (!isNaN(parseFloat(row.p_id_document))) {
            return {
                totalIva: data.total_iva_doc,
                totalWithoutIva: data.total_sin_iva_doc,
                total: data.total_doc,
                subtotal: data.subtotal_doc,
                iva: data.iva_doc,
            }
        }


        let total = 0
        let totalWithoutIva = 0
        row.p_details.forEach(r => {
            let subt = parseFloat(r.qty) * parseFloat(r.price)
            if (!isNaN(parseFloat(r.qty) * parseFloat(r.price))) {
                if (isNaN(parseFloat(r.exempt))) {
                    total += subt
                } else {
                    totalWithoutIva += subt
                }
            }
        })
        let subtotal = parseFloat(total / (1 + ivaTax))
        if (isNaN(subtotal)) {
            subtotal = 0
        }
        let iva = parseFloat(total - parseFloat(total / (1 + ivaTax)))
        if (isNaN(iva)) {
            iva = 0
        }

        if (isUsa) {
            subtotal = parseFloat(total)
            total = parseFloat(total * (1 + ivaTax))
            iva = parseFloat(total - subtotal)
        }

        let finalTotal = total + totalWithoutIva;
        /* let discountAmount = 0;
        if (discount.status) {
            discountAmount = parseFloat(finalTotal * discount.discount)
            finalTotal = finalTotal - discountAmount
        } */

        return {
            totalIva: total.toFixed(2),
            totalWithoutIva: totalWithoutIva.toFixed(2),
            total: (finalTotal).toFixed(2),
            subtotal: subtotal.toFixed(2),
            iva: iva.toFixed(2)
        }
    }, [row.p_id_document, row.p_details, ivaTax, isUsa, data.total_iva_doc, data.total_sin_iva_doc, data.total_doc, data.subtotal_doc, data.iva_doc])

    const cashbackReturn = useCallback(_ => {
        if (isNaN(parseFloat(cashback))) {
            return ''
        }

        if (getSubtotal().total > parseFloat(cashback)) {
            return ''
        }

        return parseFloat(parseFloat(cashback) - getSubtotal().total).toFixed(2)
    }, [cashback, getSubtotal])

    const dataSubmit = useCallback(() => {
        return {
            ...row,
            p_details: row.p_details.map(r => {
                return {
                    p_id_product: r.id_product,
                    p_key_product: r.key_product,
                    p_name_product: r.name_product,
                    p_price: r.price,
                    p_qty: r.qty,
                    p_point: r.point,
                    p_value_business: r.value_business,
                    p_pack_product: r.pack_product,
                    p_is_promo: r.is_promo,
                    p_type_promo: r.type_promo
                }
            }),
            p_total_doc: getSubtotal().total,
            p_subtotal_doc: getSubtotal().subtotal,
            p_iva_doc: getSubtotal().iva,
            p_total_iva_doc: getSubtotal().totalIva,
            p_total_sin_iva_doc: getSubtotal().totalWithoutIva,
            p_id_type_format_pay: row.p_id_type_format_pay,
            p_sponsor_received: row.p_sponsor_received,
            p_id_sponsor: row.p_id_sponsor,
            p_has_promo: saleHasPromo ? 1 : 0,
            p_rfc_customers: isUsa ? '' : row.p_customers_info?.rfc_customers,
            p_id_regimen: isUsa ? '' : row.p_customers_info?.id_regimen,
            p_zip_code_customers: isUsa ? '' : row.p_customers_info?.zip_code_customers,
            p_id_cfdi: isUsa ? '' : row.p_customers_info?.id_cfdi,
            p_payment_form_facturama: isUsa ? '' : row.p_customers_info?.payment_form_facturama,
            p_full_name_customers: isUsa ? '' : row.p_full_name_invoice,
            p_invoice_change: isUsa ? 0 : row.p_invoice_change,
            p_has_discount: discount.status ? 1 : 0,
            p_discount_type: discount.status ? discount.discount_type : '',
            p_discount_amount: discount.status ? discount.discount : 0
        }
    }, [row, getSubtotal, saleHasPromo, isUsa, discount])

    const pointRest = useCallback(() => {
        if (row.p_id_customers) {
            let point = 0
            row.p_details.forEach(d => {
                point += isNaN(parseInt(d.qty)) ? 0 : parseInt(d.point) * parseInt(d.qty)
            })

            let rest = (Helpers.config.pointMinRange + parseInt(data.point_sale)) - (point + parseInt(row.p_point_current_customers))
            return rest > 0 ? rest : 0
        }

        return ''
    }, [row, data.point_sale])

    const pointCurrent = useCallback(() => {
        if (row.p_id_customers) {
            let point = 0
            row.p_details.forEach(d => {
                point += isNaN(parseInt(d.qty)) ? 0 : parseFloat(d.point) * parseInt(d.qty)
            })

            return (row.p_point_current_customers - data.point_sale) + point
        }

        return ''
    }, [row, data.point_sale])

    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-02-15') {
    //     return <></>
    // }

    return <>
        <ReactPlaceholder rows={7} ready={ready}>
            <FormCustom dataSubmit={dataSubmit()} onSubmit={({ data }) => {
                if (!existsStock.exists) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, Verifique Stock', toast })
                    return
                }

                if (!row.p_id_customers) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione el Cliente.', toast })
                    return
                }
                if (!row.p_id_branch_office) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione Sucursal.', toast })
                    return
                }

                if (row.p_details.length === 0) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar productos.', toast })
                    return
                }

                if (!row.p_id_period) {
                    Helpers.toast.construct({ response: 'warning', message: 'No hay periodo activo. Comunicarse con el Área responsable.', toast })
                    return
                }

                if (!row.p_id_type_format_pay) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Forma de Pago.', toast })
                    return
                }

                if (twoMethods && !row.p_id_type_format_pay_2) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Forma de Pago.', toast })
                    return
                }

                if (twoMethods) {
                    let twoFormatAmount = parseFloat(parseFloat(row.p_amount_format_pay) + parseFloat(row.p_amount_format_pay_2)).toFixed(2)
                    if (twoFormatAmount !== parseFloat(getSubtotal().total).toFixed(2)) {
                        Helpers.toast.construct({ response: 'warning', message: 'La suma de los montos no coinciden con el total', toast })
                        return
                    }
                }

                if (isNaN(parseInt(row.p_id_document)) && parseInt(row.p_has_invoice_doc) === 1 && !row?.p_customers_info?.id_regimen) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione el Régimen Fiscal.', toast })
                    return
                }

                if (isNaN(parseInt(row.p_id_document)) && parseInt(row.p_has_invoice_doc) === 1 && !row?.p_customers_info?.id_cfdi) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione el Uso de CFDI.', toast })
                    return
                }

                if (isNaN(parseInt(row.p_id_document)) && parseInt(row.p_has_invoice_doc) === 1 && !row?.p_customers_info?.payment_form_facturama) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccione la forma de pago para factura.', toast })
                    return
                }

                /* if (isNaN(parseInt(row.p_id_document))) {
                    if (saleHasPromo && parseInt(row.p_sponsor_received) === 1 && !sponsorValidated) {
                        Helpers.toast.construct({ response: 'warning', message: 'Sponsor no ha sido validado', toast })
                        return
                    }
                } */

                return onSubmit({ data })
            }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit} viewSubmit={viewSubmit}>
                {parseInt(data.anulado) === 1 && <div className='col-12 mb-4'>
                    <div>ESTADO: <strong className='text-danger'>ANULADO</strong></div>
                    <div>MOTIVO: {data.observation_anulado}</div>
                    <div>FECHA: {data.date_anulado}</div>
                    <div>USUARIO: {data.user_anulado}</div>
                </div>}
                <div className="col-12">
                    <small className="text-muted">Información del Cliente</small>
                </div>
                <div className="col-3">
                    <div className="card" style={{
                        height: 180
                    }}>
                        <div className="card-body d-flex justify-content-center align-items-center">
                            {row.p_customers_info?.id_customers ? <img src={Helpers.defaultImage({ image: row.p_customers_info?.file_photo_customers })} alt="Cliente perfil" style={{
                                maxWidth: '100%',
                                maxHeight: 150,
                                borderRadius: 10
                            }} /> : <div>
                                {/* <a href='/' onClick={e => {
                                    e.preventDefault()
                                    setShowModalCustomers(true)
                                }}><strong>Seleccionar Cliente</strong></a> */}
                                <span>No hay cliente seleccionado</span>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-9">
                    <div className="row">
                        <Input
                            text="Nombre Cliente"
                            placeholder="Nombre Cliente"
                            classNameParent="col-12 col-md-6 mb-2"
                            icon="far fa-user"
                            value={row.p_full_name_customers}
                            disabled
                            append={isNaN(parseInt(row.p_id_document)) ? [
                                <Button onClick={_ => setShowModalCustomers(true)}>
                                    <i className="fa fa-search"></i>
                                </Button>
                            ] : []}
                        />
                        <Input
                            text="Email"
                            placeholder="Email"
                            classNameParent="col-12 col-md-6 mb-2"
                            icon="far fa-envelope"
                            value={row.p_email_customers}
                            disabled
                        />
                        <Input
                            text="Puntos Actuales"
                            placeholder="Puntos Actuales"
                            classNameParent="col-12 col-md-6 mb-2"
                            icon="fas fa-sort-numeric-up-alt"
                            value={pointCurrent()}
                            className="text-center"
                            disabled
                        />
                        <Input
                            text="Puntos Faltantes"
                            placeholder="Puntos Faltantes"
                            classNameParent="col-12 col-md-6 mb-2"
                            icon="fas fa-sort-numeric-up-alt"
                            className="text-center"
                            value={pointRest()}
                            disabled
                        />
                        {isNaN(parseInt(row.p_id_document)) ? <Select
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            text="Sucursal"
                            options={listBranchOffice.map(t => {
                                return {
                                    label: t.name_branch_office,
                                    value: t.id_branch_office
                                }
                            })}
                            value={branchOffice}
                            onChange={e => {
                                if (!row.p_id_customers) {
                                    Helpers.toast.construct({ response: 'warning', message: 'Seleccionar cliente', toast })
                                    return
                                }
                                setExistsStock(notExistsStock)

                                Promise.all([
                                    Controllers.branch_office.get_branch_office_tax_shipping({
                                        p_id_branch_office: e.value
                                    }),
                                    Controllers.customers.customers_promo_pending({
                                        p_id_customers: row.p_id_customers,
                                        p_id_branch_office: e.value
                                    })
                                ]).then(res => {
                                    setIvaTax(parseFloat(res[0].data.value_tax))
                                    setIsUsa(parseInt(res[0].data.id_type_money) === 1);

                                    let detailsPromo = []
                                    res[1].data.forEach(dp => {
                                        detailsPromo.push({
                                            id_product: dp.id_product,
                                            key_product: dp.key_product,
                                            name_product: dp.name_product,
                                            price: dp.price_product,
                                            point: dp.point_product,
                                            value_business: dp.value_business_product,
                                            qty: 1,
                                            exists_current_qty_product: dp.exists_current_qty_product,
                                            pack_product: dp.pack_product,
                                            exempt: dp.exempt_1,
                                            is_promo: 1,
                                            type_promo: dp.type_promo
                                        })
                                    })

                                    setSaleHasPromo(res[1].data.length > 0)

                                    setRow({ ...row, p_id_branch_office: e.value, p_details: detailsPromo })
                                })
                            }}
                        /> : <Input
                            text="Sucursal"
                            placeholder="Sucursal"
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            value={row.p_name_branch_office}
                            disabled
                        />}
                    </div>
                </div>
                <div className="col-12">
                    <hr />
                </div>
                {/* <Input
                text="Concepto del CDFI"
                placeholder="Concepto del CDFI"
                classNameParent="col-6 col-md-4 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.concept_cfdi_doc}
                onChange={e => setRow({ ...row, p_concept_cfdi_doc: e.currentTarget.value })}
                maxLength={100}
            /> */}
                <Input
                    text="Periodo"
                    placeholder="Periodo"
                    classNameParent="col-12 col-md-6 col-md-4 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={row.p_code_period}
                    className="text-center"
                    disabled
                />
                {twoMethods && <div className='col-12'>
                </div>}
                <Select
                    classNameParent={'col-12 mb-2 col-md-' + (twoMethods ? 3 : 4)}
                    icon="far fa-building"
                    text="Forma de Pago"
                    options={listTypeFormatPay.map(t => {
                        return {
                            label: t.name_format_pay,
                            value: t.id_type_format_pay
                        }
                    })}
                    value={typeFormayPay}
                    disabled={!isNaN(parseInt(data.id_document))}
                    onChange={e => {
                        setRow({ ...row, p_id_type_format_pay: e.value })
                    }}
                    append={twoMethods || !isNaN(parseInt(data.id_document)) ? [] : [
                        <a href="/" onClick={e => {
                            e.preventDefault()
                            setRow({
                                ...row,
                                p_id_type_format_pay_2: '',
                                p_amount_format_pay: '',
                                p_amount_format_pay_2: '',
                            })
                            setTwoMethods(true)
                        }} className='align-self-center ml-2'>Agregar</a>
                    ]}
                />
                {twoMethods && <>
                    <Input
                        text="Monto 1"
                        placeholder="Monto 1"
                        classNameParent="col-6 col-md-3 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        defaultValue={data.amount_format_pay}
                        className="text-center"
                        onChange={e => {
                            setRow({ ...row, p_amount_format_pay: e.currentTarget.value })
                        }}
                        disabled={!isNaN(parseInt(data.id_document))}
                    />
                    <Select
                        classNameParent="col-6 col-md-3 mb-2"
                        icon="far fa-building"
                        text="Forma de Pago"
                        options={listTypeFormatPay.map(t => {
                            return {
                                label: t.name_format_pay,
                                value: t.id_type_format_pay
                            }
                        })}
                        value={typeFormayPay2}
                        disabled={!isNaN(parseInt(data.id_document))}
                        onChange={e => {
                            setRow({ ...row, p_id_type_format_pay_2: e.value })
                        }}
                        append={!isNaN(parseInt(data.id_document)) ? [] : [
                            <a href="/" onClick={e => {
                                e.preventDefault()
                                setTwoMethods(false)
                                setRow({
                                    ...row,
                                    p_id_type_format_pay_2: '',
                                    p_amount_format_pay: '',
                                    p_amount_format_pay_2: '',
                                })
                            }} className='align-self-center ml-2'>Quitar</a>
                        ]}
                    />
                    <Input
                        text="Monto 2"
                        placeholder="Monto 2"
                        classNameParent="col-6 col-md-3 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        defaultValue={data.amount_format_pay_2}
                        className="text-center"
                        onChange={e => {
                            setRow({ ...row, p_amount_format_pay_2: e.currentTarget.value })
                        }}
                        disabled={!isNaN(parseInt(data.id_document))}
                    />
                </>}
                <Select
                    classNameParent="col-12 col-md-4 mb-2"
                    icon="far fa-building"
                    text="Estado de Despacho"
                    options={listStatusDispatch.map(t => {
                        return {
                            label: t.name_dispatch,
                            value: t.id_dispatch
                        }
                    })}
                    value={statusDispatch}
                    onChange={e => {
                        setRow({ ...row, p_id_dispatch: e.value })
                    }}
                    disabled={!viewSubmit}
                />
                <SwitchToggle
                    id="switch-has-invoice"
                    classNameParent="col-12 mt-2 align-self-center"
                    textCheck="Tiene Factura"
                    textUnChecked="No Tiene Factura"
                    defaultChecked={parseInt(data.has_invoice_doc) === 1}
                    onChange={e => {
                        setRow({ ...row, p_has_invoice_doc: e.currentTarget.checked ? 1 : 0 })
                    }}
                    disabled={!isNaN(parseInt(row.p_id_document))}
                />
                {isNaN(parseInt(row.p_id_document)) && parseInt(row.p_has_invoice_doc) === 1 && !isUsa && <>
                    <SwitchToggle
                        id="switch-my-invoice"
                        classNameParent="col-12 mt-2 align-self-center"
                        textCheck="Factura a otro nombre"
                        textUnChecked="No factura a otro nombre"
                        defaultChecked={parseInt(data.has_invoice_doc) === 1}
                        onChange={e => {
                            setRow({ ...row, p_invoice_change: e.currentTarget.checked ? 1 : 0 })
                        }}
                        disabled={!isNaN(parseInt(row.p_id_document))}
                    />
                    <Input
                        text="Nombre Factura"
                        placeholder="Nombre Factura"
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="fas fa-user"
                        className="text-center"
                        value={row.p_full_name_invoice}
                        required
                        onChange={e => {
                            setRow({
                                ...row,
                                p_full_name_invoice: e.currentTarget.value
                            })
                        }}
                        disabled={!viewSubmit || parseInt(row.p_invoice_change) === 0}
                    />
                    <Input
                        text="RFC"
                        placeholder="RFC"
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="fas fa-sort-numeric-up-alt"
                        className="text-center"
                        value={row.p_customers_info?.rfc_customers}
                        required
                        onChange={e => {
                            setRow({
                                ...row,
                                p_customers_info: {
                                    ...row.p_customers_info,
                                    rfc_customers: e.currentTarget.value
                                }
                            })
                        }}
                        disabled={!viewSubmit}
                    />
                    <Input
                        text="Código Postal"
                        placeholder="Código Postal"
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="fas fa-sort-numeric-up-alt"
                        className="text-center"
                        value={row.p_customers_info?.zip_code_customers}
                        required
                        onChange={e => {
                            setRow({
                                ...row,
                                p_customers_info: {
                                    ...row.p_customers_info,
                                    zip_code_customers: e.currentTarget.value
                                }
                            })
                        }}
                        disabled={!viewSubmit}
                    />
                    <Select
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="far fa-building"
                        text="Uso CFDI"
                        options={cfdi.map(t => {
                            return {
                                label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                value: t.id_cfdi
                            }
                        })}
                        value={cboCfdi}
                        onChange={e => {
                            setRow({
                                ...row,
                                p_customers_info: {
                                    ...row.p_customers_info,
                                    id_cfdi: e.value,
                                    id_regimen: ''
                                }
                            })
                        }}
                        disabled={!viewSubmit}
                    />
                    <Select
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="far fa-building"
                        text="Régimen Fiscal"
                        options={regimen.filter(r => {
                            if (!row.p_customers_info.id_cfdi) {
                                return false
                            }

                            const cfdiAux = cfdi.find(t => t.id_cfdi === row.p_customers_info.id_cfdi)

                            if (!cfdiAux) {
                                return false
                            }

                            return cfdiAux.regimen_ids.includes(r.id_regimen)
                        }).map(t => {
                            return {
                                label: `${t.id_regimen} - ${t.name_regimen}`,
                                value: t.id_regimen
                            }
                        })}
                        value={cboRegimen}
                        onChange={e => {
                            setRow({
                                ...row,
                                p_customers_info: {
                                    ...row.p_customers_info,
                                    id_regimen: e.value
                                }
                            })
                        }}
                        disabled={!viewSubmit}
                    />
                    <Select
                        classNameParent="col-12 col-md-6 mt-2"
                        icon="fa fa-building"
                        text="Forma de Pago"
                        required
                        onChange={e => {
                            setRow({
                                ...row,
                                p_customers_info: {
                                    ...row.p_customers_info,
                                    payment_form_facturama: e.value
                                }
                            })
                        }}
                        value={cboFormatPayFac()}
                        options={formatPayFac.map(w => {
                            return {
                                label: w.name,
                                value: w.id
                            }
                        })}
                    />
                </>}
                {saleHasPromo && <>
                    <div className="col-12">
                        <hr />
                    </div>
                    <SwitchToggle
                        id="switch-sponsor_received"
                        classNameParent="col-12 mb-2 align-self-center"
                        textCheck="¿Lo cobra otra persona?"
                        textUnChecked="¿Lo cobra otra persona?"
                        defaultChecked={parseInt(data.sponsor_received) === 1}
                        onChange={e => setRow({ ...row, p_sponsor_received: e.currentTarget.checked ? 1 : 0 })}
                        disabled={!isNaN(parseInt(row.p_id_document))}
                    />
                    {/* parseInt(row.p_sponsor_received) === 1 && <Input
                        text="Id Sponsor"
                        placeholder="Id Sponsor"
                        classNameParent="col-6 mb-3"
                        icon="far fa-user"
                        value={row.p_id_sponsor}
                        onChange={e => setRow({ ...row, p_id_sponsor: e.currentTarget.value })}
                        disabled={!isNaN(parseInt(row.p_id_document))}
                        append={isNaN(parseInt(row.p_id_document)) ? [
                            <Button onClick={_ => {
                                setShowLoading(true)
                                setSponsorValidated(false)

                                Controllers.customers.is_my_sponsor({
                                    p_id_customers: row.p_id_customers,
                                    p_id_sponsor: row.p_id_sponsor
                                }).then(res => {
                                    setShowLoading(false)

                                    Helpers.toast.construct({ response: res.response, message: res.message, toast })
                                    if (res.response !== 'success') {
                                        return;
                                    }

                                    setSponsorValidated(true)
                                }).catch(_ => {
                                    setShowLoading(false)
                                })
                            }}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ] : []}
                    /> */}
                    {parseInt(row.p_sponsor_received) === 1 && <Input
                        text="Nombre de quien cobra"
                        placeholder="Nombre de quien cobra"
                        classNameParent="col-6 mb-3"
                        icon="far fa-user"
                        value={row.p_id_sponsor}
                        onChange={e => setRow({ ...row, p_id_sponsor: e.currentTarget.value })}
                        disabled={!isNaN(parseInt(row.p_id_document))}
                        required
                        maxLength={100}
                    />}
                </>}
                <div className="mb-2 col-12 mt-3 d-flex justify-content-between">
                    <div>
                        {isNaN(parseInt(data.id_document)) ? <Button size="sm" onClick={handleShowModalProducts}>
                            <i className="fa fa-plus mr-1"></i>Agregar Producto
                        </Button> : <div></div>}
                        {isNaN(parseInt(row.p_id_document)) ? <Button className="ml-3" size="sm" variant={isMass ? 'dark' : 'outline-dark'} onClick={_ => setIsMass(!isMass)}>Carga Masiva</Button> : ''}
                    </div>


                    {discount.status && <div className='d-flex justify-content-center'>
                        {discount.status && <div className='ml-2 badge badge-success align-self-center'>
                            Descuento {discount.discount * 100}%
                        </div>}
                    </div>}

                    <Button size="sm" className="align-self-center" disabled={existsStock.exists} variant={existsStock.exists ? 'outline-primary' : 'primary'} onClick={handleValidateStock}>
                        <i className="fa fa-check mr-1"></i>{existsStock.exists ? 'Stock Verificado' : 'Verificar Stock'}
                    </Button>
                </div>

                {isMass && isNaN(parseInt(row.p_id_document)) ? <div className="col-12 mb-2">
                    <TextArea
                        text="Listado de productos"
                        value={listProducts}
                        onChange={e => setListProducts(e.currentTarget.value)}
                        classNameParent="w-100 mb-2"
                        rows={5}
                        placeholder="Producto/cantidad separado por coma. Producto por línea:
                        ClaveProducto1, 5
                        ClaveProducto2, 10
                        "
                    />
                    <Button disabled={validateProducts} variant="info" size="sm" onClick={_ => {
                        if (!row.p_id_customers) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Cliente', toast })
                            return
                        }
                        if (!row.p_id_branch_office) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar Sucursal', toast })
                            return
                        }
                        if (!listProducts) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, agregar productos al listado', toast })
                            return
                        }
                        let existsError = false
                        let listProductsFormated = []
                        listProducts.split('\n').forEach(s => {
                            if (!existsError) {
                                let splitLine = s.split(',')
                                if (splitLine.length !== 2 && splitLine.length !== 1) {
                                    existsError = true
                                } else {
                                    if (!listProductsFormated.find(pf => pf.key_product === splitLine[0])) {
                                        listProductsFormated.push({
                                            key_product: splitLine[0],
                                            qty: parseInt(splitLine.length === 2 ? splitLine[1] : 1)
                                        })
                                    }
                                }
                            }
                        })

                        if (existsError) {
                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, revisar el formato del listado', toast })
                            return
                        }

                        setValidateProducts(true)
                        Controllers.product.get_product_type_price({
                            p_id_branch_office: row.p_id_branch_office,
                            p_id_type_price: row.p_id_type_price
                        }).then(res => {
                            let newDetails = []

                            listProductsFormated.forEach(p => {
                                let existsProductKey = res.data.find(r => r.key_product.toLowerCase() === p.key_product.toLowerCase())
                                if (existsProductKey && !row.p_details.some(r => r.key_product.toLowerCase() === p.key_product.toLowerCase())) {

                                    let priceDiscount = parseFloat(existsProductKey.price_product)
                                    if (discount.status) {
                                        priceDiscount = existsProductKey.price_product - (existsProductKey.price_product * discount.discount)
                                    }

                                    newDetails.push({
                                        id_product: existsProductKey.id_product,
                                        key_product: existsProductKey.key_product,
                                        name_product: existsProductKey.name_product,
                                        price: priceDiscount,
                                        point: existsProductKey.point_product,
                                        value_business: existsProductKey.value_business_product,
                                        qty: p.qty,
                                        exists_current_qty_product: existsProductKey.exists_current_qty_product,
                                        pack_product: existsProductKey.pack_product,
                                        exempt: existsProductKey.exempt_1,
                                    })
                                }
                            })
                            setListProducts('')
                            setIsMass(false)
                            setRow({ ...row, p_details: [...row.p_details, ...newDetails] })
                        }).catch(req => {
                            Helpers.promise.catch({ req, toast })
                        })
                            .finally(_ => {
                                setValidateProducts(false)
                                setExistsStock(notExistsStock)
                            })
                    }}>
                        {validateProducts ? <i className="fa fa-circle-notch fa-spin"></i> : <><i className="fa fa-check"></i> Agregar Productos</>}
                    </Button>
                </div> : ''}

                {!existsStock.exists && existsStock.details.products.length > 0 ? <div className="col-12">
                    <div className="alert alert-warning d-flex flex-column">
                        <span>{existsStock.details.message}</span>
                        <span className="mt-2 mb-2">Detalle</span>

                        {React.Children.toArray(existsStock.details.products.map(p => <>
                            <span>Producto: <strong>{p.key_product}</strong></span>
                            <span>Cantidad Solicitada: <strong>{p.qty_request}</strong></span>
                            <span>Stock: <strong>{p.qty}</strong></span>
                        </>))}
                    </div>
                </div> : ''}

                <div className="table-responsive col-12">
                    <table className="table table-sm table-hover table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>Clave</th>
                                <th>Descripción</th>
                                <th>Pack</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                {/* discount.status && <th>
                                    <div className='d-flex justify-content-center'>
                                        <strong>Precio con Descuento</strong>
                                        {discount.status && <div className='ml-2 align-self-center'>
                                            {discount.discount * 100}%
                                        </div>}
                                    </div>    
                                </th> */}
                                <th>Puntos</th>
                                <th>Valor Negocio</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(row.p_details.map(r => <tr>
                                <td className="text-center">{r.key_product}</td>
                                <td>
                                    <div>{r.name_product}</div>
                                    {parseInt(r.is_promo) === 1 && <span className="badge badge-info">
                                        Promoción
                                    </span>}
                                </td>
                                <td align="center">
                                    <div className={`badge badge-${parseInt(r.pack_product) === 1 ? 'success' : 'secondary'}`}>
                                        {parseInt(r.pack_product) === 1 ? 'SI' : 'NO'}
                                    </div>
                                </td>
                                <td>
                                    <Input
                                        className="text-center"
                                        required
                                        type="number"
                                        min="1"
                                        max={parseInt(r.pack_product) === 0 ? r.exists_current_qty_product : ''}
                                        /* invalid={parseInt(r.pack_product) === 0 ? 'Stock: ' + r.exists_current_qty_product : ''} */
                                        step="1"
                                        value={!isNaN(parseInt(r.qty)) ? r.qty : ''}
                                        disabled={!isNaN(parseInt(data.id_document)) || parseInt(r.is_promo) === 1}
                                        onChange={e => {
                                            setRow({
                                                ...row,
                                                p_details: row.p_details.map(rr => {
                                                    if (parseInt(r.id_product) === parseInt(rr.id_product)) {
                                                        rr.qty = e.currentTarget.value
                                                    }
                                                    return rr
                                                })
                                            })
                                            setExistsStock(notExistsStock)
                                        }}
                                        style={{
                                            minWidth: '100px'
                                        }}
                                    />
                                </td>
                                <td className="text-center">
                                    {parseFloat(r.price).toFixed(2)}
                                </td>
                                {/* <td className="text-center">
                                    {discount.status ? parseFloat(r.original_price).toFixed(2) : parseFloat(r.price).toFixed(2)}
                                </td>
                                {discount.status && <td className='text-center'>
                                    {parseFloat(r.price).toFixed(2)}
                                </td>} */}
                                <td className="text-center">
                                    {parseFloat(r.point).toFixed(2)}
                                </td>
                                <td className="text-center">
                                    {parseFloat(r.value_business).toFixed(2)}
                                </td>
                                <td>
                                    {isNaN(parseInt(data.id_document)) ? <Button size="xs" variant="danger" onClick={() => {
                                        setRow({ ...row, p_details: row.p_details.filter(rr => parseInt(rr.id_product) !== parseInt(r.id_product)) })
                                        setExistsStock(notExistsStock)
                                    }}>
                                        <i className="fa fa-trash"></i>
                                    </Button> : ''}
                                </td>
                            </tr>))}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center"><strong>Subtotal</strong></td>
                                <td align="center">{getSubtotal().subtotal}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center"><strong>IVA</strong></td>
                                <td align="center">{getSubtotal().iva} ({isNaN(ivaTax * 100) ? '' : parseFloat(ivaTax * 100).toFixed(2)}%)</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}><strong>Total</strong></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}>{getSubtotal().totalIva}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}><strong>Total sin IVA</strong></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}>{getSubtotal().totalWithoutIva}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}><strong>Total General</strong></td>
                                <td align="center" style={{
                                    fontSize: 18
                                }}>{getSubtotal().total}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {promosReceived.length > 0 && <div className='col-12'>
                    <div className="alert alert-info">
                        <span className="alert-heading">Promociones Cobradas</span>
                        {React.Children.toArray(promosReceived.map((r, i) => <div>
                            <strong>{r.key_product} - {r.name_product}</strong>
                        </div>))}
                    </div>
                </div>}

                {(
                    isNaN(parseInt(data.id_document)) && parseInt(row.p_id_type_format_pay) === 5 && getSubtotal().total > 0
                ) ? <>
                    <Input
                        text="¿Con cuánto está pagando?"
                        classNameParent="col-md-6 mb-3"
                        className="text-center"
                        type="number"
                        step="0.01"
                        value={cashback}
                        onChange={e => setCashback(e.currentTarget.value)}
                    />
                    <Input
                        text="Vuelto a entregar"
                        classNameParent="col-md-6 mb-3"
                        className="text-center font-weight-bold"
                        required
                        type="number"
                        step="0.01"
                        disabled
                        value={cashbackReturn()}
                    />
                </> : ''}
            </FormCustom>
            <ProductList showModal={modalProducts} hideModal={handleHideModalProducts} showButtonNewProduct={false} nameSingle="Producto" namePlural="Productos" separator="el" idTypePrice={row.p_id_type_price} showProductsWithPrice added={row.p_details} idBranchOffice={row.p_id_branch_office} addItem={({ idProduct, keyProduct, nameProduct, priceProduct, pointProduct, valueBusinessProduct, qtyExists, packProduct, exempt }) => {
                let priceDiscount = parseFloat(priceProduct)
                if (discount.status) {
                    priceDiscount = priceProduct - (priceProduct * discount.discount)
                }

                let newDet = ({
                    id_product: idProduct,
                    key_product: keyProduct,
                    name_product: nameProduct,
                    price: priceDiscount,
                    original_price: priceProduct,
                    point: pointProduct,
                    value_business: valueBusinessProduct,
                    qty: '',
                    exists_current_qty_product: qtyExists,
                    pack_product: packProduct,
                    exempt,
                    is_promo: 0
                })
                setRow({ ...row, p_details: [...row.p_details, newDet] })
                setExistsStock(notExistsStock)
            }} />
            <CustomersList showButttonAdd={false} show={showModalCustomers} onHide={_ => setShowModalCustomers(false)} typeList="SALE" customersAdded={row.p_id_customers ? [{ id_customers: row.p_id_customers }] : []} onAddCustomers={({ idCustomers, idBranchOffice, nameBranchOffice, emailCustomers, pointCurrentCustomers, fullNameCustomers, idTypePrice, customers }) => {
                Promise.all([
                    Controllers.branch_office.get_branch_office_tax_shipping({
                        p_id_branch_office: idBranchOffice
                    }),
                    Controllers.customers.customers_promo_pending({
                        p_id_customers: idCustomers,
                        p_id_branch_office: idBranchOffice
                    }),
                    Controllers.customers.customers_promo_received({
                        p_id_customers: idCustomers,
                    }),
                    Controllers.customers.customers_has_discount({
                        p_id_customers: idCustomers,
                    })
                ]).then(res => {
                    setIvaTax(parseFloat(res[0].data.value_tax))
                    setIsUsa(parseInt(res[0].data.id_type_money) === 1);

                    let detailsPromo = []
                    res[1].data.forEach(dp => {
                        detailsPromo.push({
                            id_product: dp.id_product,
                            key_product: dp.key_product,
                            name_product: dp.name_product,
                            price: dp.price_product,
                            point: dp.point_product,
                            value_business: dp.value_business_product,
                            qty: 1,
                            exists_current_qty_product: dp.exists_current_qty_product,
                            pack_product: dp.pack_product,
                            exempt: dp.exempt_1,
                            is_promo: 1,
                            type_promo: dp.type_promo
                        })
                    })

                    setPromosReceived(res[2].data);
                    setSaleHasPromo(res[1].data.length > 0)

                    setDiscount(res[3].data)

                    setRow({
                        ...row,
                        p_id_customers: idCustomers,
                        p_id_branch_office: listBranchOffice.some(b => parseInt(b.id_branch_office) === parseInt(idBranchOffice)) ? idBranchOffice : '',
                        p_full_name_customers: fullNameCustomers,
                        p_name_branch_office: nameBranchOffice,
                        p_email_customers: emailCustomers,
                        p_point_current_customers: pointCurrentCustomers,
                        p_id_type_price: idTypePrice,
                        p_details: detailsPromo,
                        p_customers_info: customers,
                        p_full_name_invoice: fullNameCustomers,
                    })
                    setExistsStock(notExistsStock)
                    setShowModalCustomers(false)
                })
            }} />
            <Loading show={showLoading}>
                <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
            </Loading>
        </ReactPlaceholder>

    </>
}

SaleFormTest.defaultProps = {
    data: {
        id_document: '',
        number_invoice_doc: '',
        id_customers: '',
        id_type_price: '',
        full_name_customers: '',
        name_branch_office: '',
        email_customers: '',
        point_current_customers: '',
        has_invoice_doc: '0',
        concept_cfdi_doc: '',
        id_branch_office: '',
        id_period: '',
        code_period: '',
        details: [],
        point_sale: 0,
        id_type_format_pay: '',
        id_dispatch: '',
        id_type_format_pay_2: '',
        amount_format_pay: '',
        amount_format_pay_2: '',
        sponsor_received: 0,
        id_sponsor: '',
        zip_code_invoice: '',
        full_name_invoice: '',
        invoice_change: 0,
    },
    onSubmit: () => { },
    loadSubmit: false,
    viewSubmit: true
}

export default SaleFormTest;